/** Languages offered in the UI. Native labels are intentionally not translated. */
export const LANGUAGES = [
    { code: 'en', label: 'English' },
    { code: 'zh-TW', label: '繁體中文' },
    { code: 'ja', label: '日本語' },
] as const;

export type LanguageCode = (typeof LANGUAGES)[number]['code'];

export function isSupported(lng: string | null): lng is LanguageCode {
    return !!lng && LANGUAGES.some((l) => l.code === lng);
}

/**
 * Languages whose translations haven't been proofread yet. While one is active
 * the app shows `UnproofreadTranslationNotice`; drop a code once its
 * translation has been proofread.
 */
export const UNPROOFREAD_LANGUAGES: readonly LanguageCode[] = ['ja'];

export function isUnproofread(lng: string): boolean {
    return UNPROOFREAD_LANGUAGES.some((code) => code === lng);
}
